import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { LINE_OF_BUSINESS_ENUM } from "@ptl/account-management";
import { LINK_TYPE } from "../interfaces/dynamic-link.interface";

@Component({
    selector: 'app-sso-handler',
    templateUrl: './sso-handler.component.html',
    styleUrls: ['./sso-handler.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SSOHandlerComponent implements OnInit {

  @Input() linkType: string = LINK_TYPE.SSO_LINK;
  @Input() ssoType: string;
  @Input() ssoLabel: string;
  @Input() customData?: string;
  @Input() arguments: any;
  @Input() lob: LINE_OF_BUSINESS_ENUM;

  constructor() { }

  ngOnInit() { }

}
